import { CommonModule } from '@angular/common';
import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TABLE_DEFINITION } from '@vendasta/va-filter2-table';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import {
  AuxiliaryDataAccountsTableInternalComponent,
  AuxiliaryDataAccountsTableInternalModule,
} from '../auxiliary-data-accounts-table/auxiliary-data-accounts-table-internal.component';
import { SchemaService } from '../schema-service/schema.service';
import { AccountsAuxiliaryDataTableFilterService } from './auxiliary-data-accounts-table-filters.service';
import { tableDefinitionFactory } from './auxiliary-data-accounts-table.model';

@Component({
  standalone: true,
  imports: [CommonModule, MatCardModule, AuxiliaryDataAccountsTableInternalModule],
  selector: 'aux-auxiliary-data-accounts-table',
  template: `
    <ng-container *ngIf="injector$ | async as injector; else loading">
      <ng-container *ngComponentOutlet="component; injector: injector"></ng-container>
    </ng-container>
    <ng-template #loading>
      <mat-card appearance="outlined"><div class="stencil-shimmer"></div></mat-card>
    </ng-template>
  `,
  styles: [
    `
      .stencil-shimmer {
        height: 200px;
      }
    `,
  ],
})
export class AuxiliaryDataAccountsTableComponent implements OnInit {
  @Input() enableAddToListButton = false;
  injector$: Observable<Injector>;
  component = AuxiliaryDataAccountsTableInternalComponent;

  constructor(
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    private readonly schemaService: SchemaService,
    private readonly injector: Injector,
  ) {}

  ngOnInit(): void {
    this.injector$ = this.partnerId$.pipe(
      take(1),
      switchMap((partnerId) => this.schemaService.listFieldSchemas('business', partnerId, false, '', 100)),
      map((response) => response.fieldSchemas),
      map((fieldSchemas) => {
        return Injector.create({
          providers: [
            {
              provide: AccountsAuxiliaryDataTableFilterService,
              useClass: AccountsAuxiliaryDataTableFilterService,
            },
            {
              provide: 'fieldSchemas',
              useValue: fieldSchemas,
            },
            {
              provide: 'enableAddToListButton',
              useValue: this.enableAddToListButton,
            },
            {
              provide: TABLE_DEFINITION,
              useFactory: tableDefinitionFactory,
              deps: [AccountsAuxiliaryDataTableFilterService, 'fieldSchemas', 'enableAddToListButton'],
            },
          ],
          parent: this.injector,
        });
      }),
    );
  }
}
